document.addEventListener("DOMContentLoaded", function () {
  // START MENU LOGO HIDDEN
  document.body.classList.add("js-loaded");

  const logo = document.querySelector(".header__heading");
  const menuInline = document.querySelector(".header__inline-menu");
  const menuDrawer = document.querySelector(".menu-drawer-container");
  const triggerSection = document.querySelector("#shopify-section-template--24197033492772__featured_collection");
  const isHomePage = window.location.pathname === "/";

  if (isHomePage) {
    document.body.classList.add("home-page");
  }

  function checkScroll() {
    if (window.innerWidth > 768) {
      if (isHomePage && triggerSection) {
        const sectionRect = triggerSection.getBoundingClientRect();

         if (sectionRect.top < window.innerHeight * 0.1) {
          logo.classList.add("show-logo");
          menuInline.classList.add("menu-shift");
        } else {
          logo.classList.remove("show-logo");
          menuInline.classList.remove("menu-shift");
        }
      } else {
        logo.classList.add("show-logo");
      }

      if (menuDrawer) menuDrawer.style.display = "none";
    } else {
      logo.classList.add("show-logo");
      menuInline.style.display = "none";
      menuDrawer.style.display = "";
    }
  }

  window.addEventListener("scroll", checkScroll);
  window.addEventListener("resize", checkScroll);
  checkScroll();
  // END MENU LOGO HIDDEN

  // START CART SHIPPING LOADER
  const freeShippingThreshold = 35000; // Shopify retorna valores em centavos
  const progressBar = document.getElementById("progress-bar");
  const textElement = document.getElementById("free-shipping-text");

  function updateFreeShippingBar() {
      fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
              let cartTotal = cart.total_price; // Em centavos
              let amountLeft = freeShippingThreshold - cartTotal;
              let progress = (cartTotal / freeShippingThreshold) * 100;

              if (cartTotal >= freeShippingThreshold) {
                  textElement.innerHTML = "🎉 Parabéns! Você ganhou frete grátis!";
                  progressBar.style.width = "100%";
              } else {
                  textElement.innerHTML = `Faltam R$ ${(amountLeft / 100).toFixed(2)} para frete grátis!`;
                  progressBar.style.width = `${progress}%`;
              }
          })
          .catch(error => console.error("Erro ao buscar o carrinho:", error));
  }

  updateFreeShippingBar();

  document.addEventListener("cart:updated", updateFreeShippingBar);
  // END CART SHIPPING LOADER
});
